import { RootState } from 'redux/root';
import urlPaths from 'static/constants/enums/urlPaths';
import BlockingFunction from 'static/models/blockingFunctions/BlockingFunction';
import { updatePickupLocationOnOpportunity } from 'toolboxes/server-application-buffer/opportunity-data';

export function pickupLocation(state: RootState): BlockingFunction[] {
    return [
        {
            promiseGenerator: () => updatePickupLocationOnOpportunity(state),
            blocksPageStarts: [urlPaths.orderSummary],
        },
    ];
}
